import * as Blockly from 'blockly';

export const tilmiTheme = Blockly.Theme.defineTheme('tilmiTheme', {
    name :"tilmiTheme",
    base: Blockly.Themes.Zelos,
    blockStyles: {
        logic_blocks: { colourPrimary: '#7C4DFF', colourSecondary: '#B79CFF', colourTertiary: '#5A35CC' },
        loop_blocks: { colourPrimary: '#FF8A26', colourSecondary: '#FFC08A', colourTertiary: '#D96A0E' },
        math_blocks: { colourPrimary: '#34B3FF', colourSecondary: '#8FD9FF', colourTertiary: '#0E8ED6' },
        text_blocks: { colourPrimary: '#17B169', colourSecondary: '#7AE1AF', colourTertiary: '#0E8A51' },
        variable_blocks: { colourPrimary: '#FF4FA3', colourSecondary: '#FF9ECD', colourTertiary: '#D63383' },
        procedure_blocks: { colourPrimary: '#FF5F5F', colourSecondary: '#FFA4A4', colourTertiary: '#E33F3F' },
    },
    categoryStyles: {
        logic_category: { colour: '#7C4DFF' },
        loop_category: { colour: '#FF8A26' },
        math_category: { colour: '#34B3FF' },
        text_category: { colour: '#17B169' },
        variable_category: { colour: '#FF4FA3' },
        procedure_category: { colour: '#FF5F5F' },
    },
    componentStyles: {
        workspaceBackgroundColour: '#f8f9ff',
        toolboxBackgroundColour: 'rgba(255, 255, 255, 0.94)',
        toolboxForegroundColour: '#1f2350',
        flyoutBackgroundColour: 'rgba(255, 255, 255, 0.96)',
        flyoutForegroundColour: '#1f2350',
        flyoutOpacity: 1,
        scrollbarColour: '#c5cbff',
        scrollbarOpacity: 0.75,
        insertionMarkerColour: '#68d391',
        insertionMarkerOpacity: 0.35,
        markerColour: '#5f6fff',
        cursorColour: '#5f6fff',
    },
    fontStyle: {
        family: 'Nunito, Poppins, Inter, "Segoe UI", sans-serif',
        weight: '700',
        size: 13,
    },
    startHats: true,
});

export default tilmiTheme;
